import * as api from './constants'

function resolve (res) {
  return Promise.resolve(res)
}

function reject (error) {
  let eobj
  if (error.response) {
    let data = error.response.data
    if (data.errors) {
      eobj = new Error(data.errors)
    } else if (data.message) {
      eobj = new Error(data.message)
    } else {
      eobj = new Error(error.message)
    }
  } else {
    eobj = new Error(error.message)
  }
  return Promise.reject(eobj)
}

export function getItemByIdV1 (id, params) {
  return axios.get(api.V1_ITEM_BY_ID(id), {params, withCredentials: true})
    .then(resolve)
    .catch(reject)
}

/**
 * Get list item from server
 * TODO change to getItemsV2
 */
export function getItems (params) {
  return axios
    .get(`${api.ITEMS}`, {params, withCredentials: true})
    .then(resolve)
    .catch(reject)
}

export function getItemsV2 (params) {
  return axios
    .get(`${api.V2_ITEMS}`, {params, withCredentials: true})
    .then(resolve)
    .catch(reject)
}

export function getItemsV1 (params) {
  return axios
    .get(`${api.V1_ITEMS}`, {params, withCredentials: true})
    .then(resolve)
    .catch(reject)
}



// WEBPACK FOOTER //
// ./app/api/items/items.js